import { SetStateAction } from 'react'

import useCurrentUser from '~/hooks/useCurrentUser'

import { useGetCurriculumNameFromCurriculumCountryCode } from '~/curriculum/hooks/useGetCurriculumCountryCode'

import { SettingsFields } from '../types'

export function useDefaultSettingsFields(setFields?: React.Dispatch<SetStateAction<SettingsFields>>): {
  defaultFields: SettingsFields
  setDefaultFields: () => void
} {
  const user = useCurrentUser()
  const curriculum = useGetCurriculumNameFromCurriculumCountryCode(user?.curriculumCountryCode)

  const defaultFields = {
    email: user?.facebookEmail ?? user?.email ?? user?.authEmail ?? '',
    nickname: user?.nickname ?? '',
    country: user?.country ?? '',
    curriculum: curriculum ?? '',
    birthYear: user?.birthYear ?? user?.birthdate?.slice(0, 4) ?? '',
    wantsNewsletter: user?.wantsNewsletter ?? false,

    // These fields could be null.
    userType: user?.userType !== undefined && user.userType !== null ? user.userType : '',
    skill: user?.skill !== undefined && user.skill !== null ? String(user.skill) : '',
    yearsInSchool: user?.yearsInSchool !== undefined && user.yearsInSchool !== null ? String(user.yearsInSchool) : '',
    gradeLevelId: user?.gradeLevelId !== undefined && user.gradeLevelId !== null ? String(user.gradeLevelId) : '',

    currPassword: '',
    newPassword: '',
    newPasswordConfirm: '',
  }

  const setDefaultFields = (): void => {
    if (typeof setFields === 'function') setFields(defaultFields)
  }

  return { defaultFields, setDefaultFields }
}
